import { render, staticRenderFns } from "./pivotTableCompleteDuroflex.vue?vue&type=template&id=3132e760"
import script from "./pivotTableCompleteDuroflex.vue?vue&type=script&lang=js"
export * from "./pivotTableCompleteDuroflex.vue?vue&type=script&lang=js"
import style0 from "./pivotTableCompleteDuroflex.vue?vue&type=style&index=0&id=3132e760&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports